import {
  GlobalAction,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import {
  App,
  convertBffZuersZoneIdtoZuersZoneEnum,
  ElementarSelbstbehalt,
} from '@ps20-frontend/frontend-models';
import { convertElementarSBToElementarSelbstbehalt } from '../sagas/transformer/elementarSB.transformer';
import { IAppState } from '../appState';

export function elementarSelbstbehalt(
  sectionState: ElementarSelbstbehalt = null,
  action: GlobalAction<PreiseStreckeErmittelt>,
  state: IAppState,
): ElementarSelbstbehalt {
  if (
    action.type === GlobalActions.PREISE_STRECKE_ERMITTELT &&
    action.payload.appId === App.VWG &&
    action.payload.angebotsId === state.angebotsId &&
    !state.vertragsoptionen?.beibehalten
  ) {
    const actionPayload: PreiseStreckeErmittelt = action.payload;
    if (
      sectionState.id !==
      convertBffZuersZoneIdtoZuersZoneEnum(actionPayload.taasResponsePayload.elementarSB.id)
    ) {
      return convertElementarSBToElementarSelbstbehalt(
        actionPayload.taasResponsePayload.elementarSB,
      );
    }
  }
  return sectionState;
}
